import React from "react";
import Column2 from "../../components/Containers/Columns-2";
import Form from "../../components/Widgets/Form";
import RaisedButton from "../../components/Widgets/Button";
import { TextField, HalfTextField} from "../../components/Widgets/Input";
import { Link } from "react-router-dom";


function SignUp() {
  return (
    <div className="container-element">
      <Form heading="Sign Up">

        <Column2>
          <HalfTextField type="text" id="firstname" hint_text="Firstname" />
          <HalfTextField type="text" id="lastname" hint_text="Lastname" />
        </Column2>

        <Column2>
          <HalfTextField type="text" id="username" hint_text="Username" />
          <HalfTextField type="number" id="phone" hint_text="Mobile" />
        </Column2>

        <TextField type="email" id="email" hint_text="EMail" />
        <TextField type="text" id="country" hint_text="Country" />

        <Column2>
          <HalfTextField type="password" id="auth" hint_text="Password" />
          <HalfTextField type="password" id="confirm-auth" hint_text="Confirm Password" />
        </Column2>

        <div className="form-action-buttons">
          <RaisedButton variant="button-primary" text="SignUp" />
          <Link className="link-primary" to="/tracemall/login">Already have an Account? Login</Link>
        </div>

      </Form>

    </div>
  );
}

export default SignUp;